import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { createTask, updateTask } from 'bundles/apex/playbooks/config/store/playbooks/actions';
import { titleize } from 'helpers/formatters/string_formats';

import Assignee from './assignee';
import Button from 'shared/button';
import DueDates from './due_dates';
import Errors from 'components/form/errors';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import ManagedInput from 'components/form/managed_input';
import Modal from 'components/modal';

import './styles.scss';

export function TaskModal({
  canRequirePlaybookTasks,
  createTask,
  offices,
  playbook,
  stage,
  stages,
  task,
  updateTask,
  users,
  onHide,
}) {
  stage = stage || stages[task.stage];
  const [name, setName] = useState(task?.name);
  const [required, setRequired] = useState(task?.required ? 'true' : 'false');
  const [requiresAttachment, setRequiresAttachment] = useState(task?.requiresAttachment ? 'true' : 'false');
  const [assignee, setAssignee] = useState({ assigneeId: task?.assignee?.id, assigneeType: task?.assigneeType });
  const [officeAssigneeIds, setOfficeAssigneeIds] = useState(task?.officeAssigneeIds ? task.officeAssigneeIds : {});
  const [dueDate, setDueDate] = useState();
  const [errors, setErrors] = useState();
  const [saving, setSaving] = useState();
  const [createTasks, setCreateTasks] = useState();
  async function handleSave() {
    setSaving(true);
    const updatedTask = {
      office_assignee_ids: officeAssigneeIds,
      name,
      stage: stage.key,
      required,
      requiresAttachment,
      ...(dueDate),
      ...assignee
    };

    try {
      if (task) {
        updatedTask.id = task.id;
        await updateTask(playbook, task, updatedTask);
      } else {
        updatedTask.createTasks = createTasks;
        await createTask(playbook, updatedTask);
      }
      onHide();
    } catch (errors) {
      setErrors(errors);
      setSaving(false);
    }
  }

  return (
    <Modal className="playbook-tasks-modal" show onHide={onHide}>
      <Modal.Header closeButton>
        {task ? 'Edit Task' : 'Add Task'}
      </Modal.Header>

      <Modal.Body>
        <Errors errors={errors} />
        <div className="form playbook-task-form">
          <ManagedFormGroup
            className="task-name"
            label="Task Name"
            name="name"
            required
            value={name}
            onValueChange={setName}
          />

          {canRequirePlaybookTasks &&
            <ManagedFormGroup
              label="Required for Voucher Submission"
              name="required"
              type="select"
              value={required}
              onValueChange={setRequired}
            >
              <option value="false">
                No
              </option>
              <option value="true">
                Yes
              </option>
            </ManagedFormGroup>}

          <ManagedFormGroup
            label="Require Attachment"
            name="requireAttachment"
            type="select"
            value={requiresAttachment}
            onValueChange={setRequiresAttachment}
          >
            <option value="false">
              No
            </option>
            <option value="true">
              Yes
            </option>
          </ManagedFormGroup>

          <Assignee assignee={assignee}
            officeAssigneeIds={officeAssigneeIds}
            offices={offices}
            setAssignee={setAssignee}
            setOfficeAssigneeIds={setOfficeAssigneeIds}
            users={users} 
          />

          <DueDates
            playbook={playbook}
            setDueDate={setDueDate}
            task={task}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="playbook-tasks-footer">
          <div>
            {!task &&
              <ManagedInput
                name="createTasks"
                type="checkbox"
                value={createTasks}
                onValueChange={setCreateTasks}
              >
                Add task to existing {titleize(playbook.dealType)} deals ({stage.label} only)
              </ManagedInput>}
          </div>

          <div>
            <Button.Cancel name="cancel" onClick={onHide} />
            <Button.Primary disabled={!name || saving} name="save" onClick={handleSave}>
              Save Task
            </Button.Primary>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

TaskModal.propTypes = {
  canRequirePlaybookTasks: PropTypes.bool,
  createTask: PropTypes.func.isRequired,
  offices: PropTypes.array,
  playbook: PropTypes.shape({
    dealType: PropTypes.string.isRequired,
    tasksPath: PropTypes.string.isRequired,
  }).isRequired,
  stage: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  stages: PropTypes.object.isRequired,
  task: PropTypes.object,
  updateTask: PropTypes.func.isRequired,
  users: PropTypes.array.isRequired,
  onHide: PropTypes.func.isRequired,
};

TaskModal.defaultProps = {
  offices: [],
};

const mapStateToProps = state => ({
  canRequirePlaybookTasks: state.canRequirePlaybookTasks,
  stages: state.stages,
  offices: state.offices,
  users: state.users
});

const mapDispatchToProps = {
  createTask,
  updateTask,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskModal);
